import React from "react";
import { TriangleAlert } from "lucide-react";
import { useTranslation } from "react-i18next";

/** Shown when vision is "Severe Visual Impairment": screening can't be performed. */
export const SevereVisionWarning: React.FC = () => {
  const { t } = useTranslation("patients");
  return (
    <div
      role="alert"
      className="flex items-start gap-3 rounded-lg border border-red-200 bg-red-50 p-3 text-sm text-red-700"
    >
      <TriangleAlert className="mt-0.5 h-4 w-4 shrink-0" />
      <p>{t("clinicalSections.vision.severeWarning")}</p>
    </div>
  );
};
